<template>
  <b-card class="confirmation-login">
    <div class="headings">
      <div class="headings-block">
        <h4>Sign in or</h4>
        <h4>create an account</h4>
      </div>
      <div class="secondary-text-block">
        <div>View your catering history and</div>
        <div>check order status</div>
      </div>
    </div>
    <login-form
      class="login-form"
      @login-success="$emit('login-success')"
      @forgot-password-click="$emit('forgot-password-click')"
      @create-an-account-click="$emit('create-an-account-click')"
    />
  </b-card>
</template>

<script>
import LoginForm from '@/components/account/Login'

export default {
  components: {
    LoginForm,
  },
}
</script>

<style lang="scss">
.confirmation-login {
  .headings {
    text-align: center;
  }
  h4 {
    margin: 0;
    text-transform: uppercase;
  }
  .headings-block,
  .secondary-text-block {
    margin-bottom: 10px;
  }
}
@include media-breakpoint-up(md) {
  .confirmation-login {
    .login-form {
      max-width: 300px;
      margin: 0 auto;
    }
  }
}
</style>
